import { render, staticRenderFns } from "./SuppliersDetails.vue?vue&type=template&id=2028560e&scoped=true"
import script from "./SuppliersDetails.vue?vue&type=script&lang=js"
export * from "./SuppliersDetails.vue?vue&type=script&lang=js"
import style0 from "./SuppliersDetails.vue?vue&type=style&index=0&id=2028560e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028560e",
  null
  
)

export default component.exports